export default __webpack_public_path__ + "static/media/delete.8690a12f.svg";